module.exports = __webpack_public_path__ + "static/media/information-color.c10425d9.svg";